import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Link } from "react-router-dom";
import { formatAppDate } from "../../helpers/date-formatter";
import DataTable from "../table/DataTable";
import { MediaCell } from "../table/DataTableCell";
import StatusBadge from "../table/StatusBadge";
import ActionGroup, { ActionButton } from "../table/ActionGroup";

function PromoBannerTable({ banners, onDelete }) {
  const columns = [
    {
      key: "banner",
      label: "Banner",
      render: (banner) => (
        <MediaCell
          src={banner.bannerUrl}
          alt={banner.description}
          title={banner.description}
          size="lg"
        />
      ),
    },
    {
      key: "status",
      label: "Status",
      width: "150px",
      render: (banner) => <StatusBadge active={banner.active} />,
    },
    {
      key: "position",
      label: "Order",
      width: "120px",
      render: (banner) => banner.position,
    },
    {
      key: "createdOn",
      label: "Created On",
      width: "150px",
      render: (banner) => formatAppDate(banner.createdOn),
    },
    {
      key: "actions",
      label: "Actions",
      align: "right",
      width: "120px",
      render: (banner) => (
        <ActionGroup>
          <ActionButton as={Link} to={`/promo-banner/${banner.id}/edit`} color="blue" title="Edit">
            <PencilSquareIcon className="h-5 w-5" />
          </ActionButton>
          <ActionButton color="red" onClick={() => onDelete(banner)} title="Delete">
            <TrashIcon className="h-5 w-5" />
          </ActionButton>
        </ActionGroup>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={banners}
      rowKey="id"
      minWidth="820px"
      emptyMessage="No promo banners found."
    />
  );
}

export default PromoBannerTable;
